var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"items"},_vm._l((_vm.items),function(i,idx){return _c('div',{key:i.name,staticClass:"item",on:{"click":function($event){return _setup.handleClick(idx)}}},[_c('font-awesome-icon',{attrs:{"icon":_setup.playBtn}}),_c('span',[_vm._v(_vm._s(i.name))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }